export const MAINUI_NAV_PANEL_TOGGLE = 'MAINUI_NAV_PANEL_TOGGLE';
export const MAINUI_WORKSPACE_PREVIEW_TOGGLE = 'MAINUI_WORKSPACE_PREVIEW_TOGGLE';
export const MAINUI_UMO_DETAIL_VIEW_TOGGLE = 'MAINUI_UMO_DETAIL_VIEW_TOGGLE';
export const MAINUI_UMO_COMPARE_VIEW_TOGGLE = 'MAINUI_UMO_COMPARE_VIEW_TOGGLE';
export const MAINUI_WORKSPACE_DETAIL_VIEW_TOGGLE = 'MAINUI_WORKSPACE_DETAIL_VIEW_TOGGLE';
export const MAINUI_ADVANCED_SEARCH_TOGGLE = 'MAINUI_ADVANCED_SEARCH_TOGGLE';
export const MAINUI_MANUAL_SORT_TOGGLE = 'MAINUI_MANUAL_SORT_TOGGLE';

export const MAINUI_UMO_GRID_VIEW = 'MAINUI_UMO_GRID_VIEW';
export const MAINUI_UMO_GRID_NOJ_VIEW = 'MAINUI_UMO_GRID_NOJ_VIEW';
export const MAINUI_UMO_LIST_VIEW = 'MAINUI_UMO_LIST_VIEW';
export const MAINUI_UMO_SM_GRID_NOJ_VIEW = 'MAINUI_UMO_SM_GRID_NOJ_VIEW';

export const MAINUI_SHOW_MAIN_SEARCH = 'MAINUI_SHOW_MAIN_SEARCH';
export const MAINUI_SHOW_HIGHLIGHTS = 'MAINUI_SHOW_HIGHLIGHTS';
export const MAINUI_SHOW_ADMIN_SCREEN = 'MAINUI_SHOW_ADMIN_SCREEN';

export const MAINUI_SHOW_MAIN_ADMIN_SUCCESS = 'MAINUI_SHOW_MAIN_ADMIN_SUCCESS';
export const MAINUI_SHOW_MAIN_ADMIN_LOADING = 'MAINUI_SHOW_MAIN_ADMIN_LOADING';
export const MAINUI_SHOW_MAIN_ADMIN_FAILURE = 'MAINUI_SHOW_MAIN_ADMIN_FAILURE';
export const MAINUI_SHOW_MAIN_EXTERNAL_SUCCESS = 'MAINUI_SHOW_MAIN_EXTERNAL_SUCCESS';
export const MAINUI_SHOW_MAIN_EXTERNAL_LOADING = 'MAINUI_SHOW_MAIN_EXTERNAL_LOADING';
export const MAINUI_SHOW_MAIN_EXTERNAL_FAILURE = 'MAINUI_SHOW_MAIN_EXTERNAL_FAILURE';

export const MAINUI_TOGGLE_FULL_IMAGE_VIEW = 'MAINUI_TOGGLE_FULL_IMAGE_VIEW';

export const MAINUI_SHOW_WORKSPACE_EMAIL_DIALOG = 'MAINUI_SHOW_WORKSPACE_EMAIL_DIALOG';
export const MAINUI_HIDE_WORKSPACE_EMAIL_DIALOG = 'MAINUI_HIDE_WORKSPACE_EMAIL_DIALOG';

export const MAINUI_SHOW_UMO_MODIFY_DIALOG = 'MAINUI_SHOW_UMO_MODIFY_DIALOG';
export const MAINUI_HIDE_UMO_MODIFY_DIALOG = 'MAINUI_HIDE_UMO_MODIFY_DIALOG';

export const MAINUI_SHOW_CATEGORY_MOVE_DIALOG = 'MAINUI_SHOW_CATEGORY_MOVE_DIALOG';
export const MAINUI_HIDE_CATEGORY_MOVE_DIALOG = 'MAINUI_HIDE_CATEGORY_MOVE_DIALOG';

export const MAINUI_SHOW_MAIN_DIALOG = 'MAINUI_SHOW_MAIN_DIALOG';
export const MAINUI_HIDE_MAIN_DIALOG = 'MAINUI_HIDE_MAIN_DIALOG';



// WEBPACK FOOTER //
// ./src/js/actions/mainUIActionTypes.js